<template>
  <div
    class="component-left-container-1 card-background"
    style="height: 60%; margin-bottom: 12px"
  >
    <el-card style="height: 100%">
      <div slot="header" class="clearfix">
        <div class="header flex items-center justify-center">
          <div class="font-bold" style="font-size: 26px">
            <!-- <i
              class="el-icon-s-goods"
              style="font-size: 26px; color: #4bace0"
            ></i>
            {{ data && data.name }} -->

            <div class="cc-header flex justify-around items-center p-0">
              <dv-decoration-1 style="width: 100px; height: 20px" />
              <div class="font-bold" style="font-size: 26px">
                <!-- {{ data && data.name }} -->
                价格
              </div>
              <dv-decoration-1 style="width: 100px; height: 20px" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-table
          :data="priceList"
          ref="scrollTable"
          style="width: 100%"
          class-name="table-name"
          height="450px"
          :show-header="false"
          :border="false"
          :header-cell-style="{
            color: '#333',
            borderColor: '#e2c6c0',
          }"
          :cell-style="{ borderColor: '#e2c6c0' }"
          :row-style="{
            backgroundColor: 'transparent',
            borderColor: '#e2c6c0',
          }"
        >
          <!-- <el-table-column
            v-for="(it, index) in column"
            :key="index"
            :prop="it.prop"
            :label="it.label"
            align="center"
            :width="it.width"
          >
          </el-table-column> -->
          <el-table-column>
            <template slot-scope="{ row }">
              <div>
                <!-- <div class="channel" style="width: 200px">
                  <el-tooltip
                    effect="dark"
                    :content="row.goodsName"
                    placement="top-start"

                  >
                    <b>【{{ row.goodsCategoryName }}】{{ row.goodsName }}</b>
                  </el-tooltip>
                </div> -->
                <div>
                  <b>【{{ row.goodsCategoryName }}】{{ row.goodsName }}</b>
                </div>
                <div class="flex justify-between mt-2">
                  <div>
                    服务价格：¥{{ Number(row.sellingPrice / 100).toFixed(2) }}
                  </div>
                  <!-- <div>民政补贴：¥0</div> -->
                  <div
                    v-if="row.shops && row.shops[0] && row.shops[0].belongTo"
                    class="channel"
                  >
                    <el-tooltip
                      effect="dark"
                      :content="row.shops[0].name"
                      placement="top-start"
                    >
                      <span class="content"
                        >服务机构:{{ row.shops[0].name }}
                      </span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="price" label="价格" align="center" width="160">
          </el-table-column> -->
        </el-table>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      scrolltimer: "", // 自动滚动的定时任务
      priceList: [],
    };
  },
  props: {
    data: Object,
    default: () => {},
    column: {
      type: Object,
      default: () => {
        return [
          {
            label: "项目",
            prop: "name",
          },
          {
            label: "价格",
            prop: "price",
            width: "160",
          },
        ];
      },
    },
  },
  // watch: {
  //   data: {
  //     handler(n) {
  //       if (n.list) {
  //         let listJson = this.formatJson(n.list[0].content);
  //         try {
  //           this.list = JSON.parse(listJson);
  //           console.log("list哈哈哈哈哈哈", this.list);
  //         } catch (error) {
  //           this.list = [];
  //         }
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  mounted() {
    this.getShopList();
    this.autoScroll();
  },
  methods: {
    getShopList() {
      this.$axios
        .get("/mcapi/mallService/mechanism/goods/list", {
          params: {
            pageSize: 100,
          },
        })
        .then((resp) => {
          this.priceList = resp.data.list;
        });
    },

    formatJson(str) {
      if (!str) return;
      str = str.replaceAll(/<\/?[^>]+>/g, "");

      console.log(str);
      return str;
    },
    // 设置自动滚动
    autoScroll(stop) {
      const table = this.$refs.scrollTable;
      // 拿到表格中承载数据的div元素
      const divData = table.$refs.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      if (stop) {
        //再通过事件监听，监听到 组件销毁 后，再执行关闭计时器。
        window.clearInterval(this.scrolltimer);
      } else {
        this.scrolltimer = window.setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 1;
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          if (
            parseInt(divData.clientHeight) + parseInt(divData.scrollTop) ==
            parseInt(divData.scrollHeight)
          ) {
            // 重置table距离顶部距离
            divData.scrollTop = 0;
            // 重置table距离顶部距离。值=(滚动到底部时，距离顶部的大小) - 整个高度/2
            // divData.scrollTop = divData.scrollTop - divData.scrollHeight / 2
          }
        }, 100); // 滚动速度
      }
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .el-card {
    background-color: transparent !important;
  }
  .row-item {
    border-bottom: 1px solid @border-color !important;
  }
  .el-table,
  .el-table__expanded-cell {
    background: none;
  }
}
.channel {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
// ::v-deep {
//   .el-card__body {
//     padding: 0;
//   }
//   .el-table,
//   .el-table__body {
//     background: transparent !important;
//     color: #fff;
//     font-size: 20px;
//   }
//   .el-table th {
//     background-color: transparent !important;
//   }
//   .el-table tr {
//     background-color: transparent !important;
//   }

//   .el-table td {
//     background-color: transparent !important;
//   }
//   .el-table__body tr.hover-row > td {
//     background-color: #a5ccf2 !important;
//   }
//   .el-table tbody tr:hover > td {
//     background-color: #17468d !important //修改成自己想要的颜色即可;;
//   }
//   .table-name {
//     border: 1px solid #4bace0;
//   }
//   .el-table--border::after,
//   .el-table--group::after,
//   .el-table::before {
//     background-color: transparent;
//     height: 0;
//   }
// }
</style>
